import React, { useEffect, useState } from 'react'
import { fetchBrands } from '../../utils/api';
import { NavLink, useLocation } from 'react-router-dom';
import './sell-mobile.css';
import sellIcon from '../../assets/images/sell-img.png';
import { brandImagePath } from '../../utils/constants';
import Loader from '../../components/loader/loader';
import BestPrice from '../../assets/images/icon/best-price.png';
import Shield from '../../assets/images/icon/shield.png';
import DeliveryMan from '../../assets/images/icon/delivery-man.png';
import TestimonialSlider from "../../components/testimonial-slider/TestimonialSlider";
import ResearchImg from '../../assets/images/icon/research.png';
import PickUpImg from '../../assets/images/icon/pickup.png';
import WalletImg from '../../assets/images/icon/wallet.png';

const SellMobile = () => {

    const [brandsData, setBrandsData] = useState(null);
    const [loading, setLoading] = useState(true);
    const imagePath = '../../assets/images/brands';

    const [searchQuery, setSearchQuery] = useState('');
    const [filteredBrands, setFilteredBrands] = useState([]);
    const [city, setCity] = useState(localStorage.getItem("selectedCity") || "hyderabad");
    const location = useLocation(); // Detect route changes

    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchBrands();
                setBrandsData(response);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching sell mobile data:', error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);
    useEffect(() => {
        const filterBrands = () => {
            if (brandsData && brandsData.length > 0) {
                const filteredData = brandsData.filter(item =>
                    item.CategoryGroupName.toLowerCase().includes(searchQuery.toLowerCase())
                );
                setFilteredBrands(filteredData);
            }
        };

        filterBrands();
    }, [brandsData, searchQuery]);

    return (
        <>
            {loading && <Loader />}
            <section className="Search-section section-padding" id="section_1" style={{ paddingTop: "0px" }}>
                <div className="container bgsellSearch">
                    <div style={{ padding: "10px" }}>
                        <div className='sell-result-Desktop'>
                            <div className="row " >

                                <div className="col-lg-7 col-md-7 col-12 mb-4 mb-lg-0">
                                    <div className='mb-5'>
                                        <h5 className="mt-5 mb-0 mb-4"><span className="extraFont1">Get Instant Cash for Your Mobile!</span></h5>

                                    </div>

                                    <form action="#" method="get" className="custom-form search-form flex-fill me-0" role="search">
                                        <div className="input-group input-group-lg">
                                            {/* <input name="search" type="search" className="form-control" id="search" placeholder="Search For..."
                                                aria-label="Search" /> */}
                                            <input
                                                name="search"
                                                type="search"
                                                className="form-control"
                                                id="search"
                                                placeholder="Search For..."
                                                aria-label="Search"
                                                value={searchQuery}
                                                onChange={handleSearchInputChange}
                                            />

                                            <button type="submit" className="form-control" id="submit">
                                                <i className="bi-search"></i>
                                            </button>
                                        </div>
                                    </form>
                                    <div className='row mt-4'>
                                        <div className='col-md-4' style={{ fontWeight: "500" }}>

                                            <p className=''><img src={BestPrice} className="img-fluid" alt="" width={35} height={200} /><b> <span className='font14'>Best Price Guaranteed</span> </b></p>
                                        </div>
                                        <div className='col-md-4' style={{ fontWeight: "500" }}>

                                            <p className=''><img src={Shield} className="img-fluid" alt="" width={30} height={200} /><b> <span className='font14'>100% Safe & Hassle-Free</span></b></p>

                                        </div>
                                        <div className='col-md-4' style={{ fontWeight: "500" }}>

                                            <p className=''><img src={DeliveryMan} className="img-fluid" alt="" width={30} height={200} /><b> <span className='font14'>Free Doorstep Pickup</span> </b> </p>

                                        </div>
                                    </div>
                                    <p className='mt-3'>Sell your old phone in minutes—quick, secure, and effortless! </p>
                                </div>
                                <div className="col-lg-5 col-md-5 col-12 mb-4 mb-lg-0">
                                    <img src={sellIcon} className="custom-block-image img-fluid"
                                        alt="" style={{ width: "60%", height: "auto", margin: "0 auto" }} />
                                </div>

                            </div>
                        </div>

                        <div className="row sell-result-Mobile mt-4" >
                            <div className="col-lg-12 col-md-12 col-12 mb-4 mt-0 mb-lg-0">
                                <div className='mb-5'>
                                    <h1 className="mt-5 mb-0 mb-4"><span className="extraFont1">Get Instant Cash for Your Mobile!</span></h1>
                                </div>
                                <ul className='mt-4'>
                                    <li className='me-2 mt-2' style={{ fontWeight: "500" }}>
                                        <p className=''><img src={BestPrice} className="img-fluid" alt="" width={35} height={200} /><b> <span className='font14'>Best Price Guaranteed</span> </b></p>

                                    </li>
                                    <li className='me-2 mt-2' style={{ fontWeight: "500" }}>
                                        <p className=''><img src={Shield} className="img-fluid" alt="" width={30} height={200} /><b> <span className='font14'>100% Safe & Hassle-Free</span></b></p>
                                    </li>
                                    <li className='me-2 mt-2' style={{ fontWeight: "500" }}>
                                        <p className=''><img src={DeliveryMan} className="img-fluid" alt="" width={30} height={200} /><b> <span className='font14'>Free Doorstep Pickup</span> </b> </p>
                                    </li>
                                </ul>
                                <p className='mt-3'>Sell your old phone in minutes—quick, secure, and effortless! </p>
                            </div>

                        </div>
                    </div>

                </div>
            </section>

            <section className="about-section section-padding" id="section_2" style={{ paddingTop: "0px" }}>

                <div className="container">
                    <div className="col-lg-12 col-12">
                        <div className="section-title-wrap mb-3">
                            <h4 className="section-title">Choose your brand</h4>
                        </div>
                    </div>
                    <div className='sell-result-Desktop'>
                        <div className="row">

                            {loading ? (
                                <div className="skeleton-loading">
                                    <div className="skeleton-row"></div>
                                    <div className="skeleton-row"></div>
                                    <div className="skeleton-row"></div>
                                </div>
                            ) : (
                                <>
                                    {filteredBrands.length === 0 ? (
                                        <h4 className='pl-1'>No matching brands found</h4>
                                    ) : (
                                        filteredBrands.map((item, index) => (
                                            <div className="col-lg-2 col-md-6 col-12 mb-5 mb-lg-3" key={item.id}>
                                                <NavLink to={`/${city?.toLowerCase()}/sell-mobile/${item.slug}`} style={{ width: '100%' }}>
                                                    <div className="team-thumb bg-white shadow-lg">
                                                        <img src={brandImagePath + item.image} width="106" alt={item.CategoryGroupName} />
                                                        <h6 className='font-weight-normal font14'>{item.CategoryGroupName}</h6>
                                                    </div>


                                                </NavLink>
                                            </div>

                                        ))
                                    )}
                                </>
                            )}

                        </div>
                    </div>
                    <div className='sell-result-Mobile'>
                        <div className="row">

                            {loading ? (
                                <div className="skeleton-loading">
                                    <div className="skeleton-row"></div>
                                    <div className="skeleton-row"></div>
                                    <div className="skeleton-row"></div>
                                </div>
                            ) : (
                                <>

                                    {filteredBrands.length === 0 ? (
                                        <h4 className='pl-1'>No matching brands found</h4>
                                    ) : (
                                        filteredBrands.map((item, index) => (
                                            <div className="col-lg-4 col-md-4 col-4 mb-5 mb-lg-3" key={item.id}>
                                                <NavLink to={`/sell-mobile/${item.slug}`} style={{ width: '100%' }}>
                                                    <div className="team-thumb bg-white shadow-lg">
                                                        <img src={brandImagePath + item.image} width="106" alt={item.CategoryGroupName} />
                                                        <h6 className='font-weight-normal font14'>{item.CategoryGroupName}</h6>

                                                    </div>
                                                </NavLink>
                                            </div>
                                        ))
                                    )}
                                </>
                            )}

                        </div>
                    </div>
                </div>
            </section>
            <section className="about-section section-padding" id="section_2" style={{ paddingTop: "0px" }}>
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12 col-12 mx-auto">
                            <div className="pb-0 mb-0">
                                <div className="section-title-wrap mb-4">
                                    <h4 className="section-title">  Sell Your Old Devices for Instant Cash with CellCash.in
                                    </h4>
                                </div>

                                <p>Looking to sell mobile online in Hyderabad? CellCash.in offers the fastest and most
                                    convenient way to get instant cash for your old or used mobile phone. With our quick
                                    doorstep pickup service, you don’t have to step out or go through complicated processes.
                                    Just enter your device details, get an instant quote, and enjoy a hassle-free selling
                                    experience at the best market price.

                                </p>

                                <p>
                                    Our platform makes selling used gadgets simple and efficient. Whether you want to sell
                                    mobile phones online in Hyderabad, trade in a second-hand laptop, or sell a pre-owned tablet
                                    or smartwatch, you can do it in just a few clicks. Simply select your device brand, provide the
                                    necessary details, and receive an immediate price estimate. No waiting, no hidden
                                    charges—just a seamless process designed for your ease.
                                </p>
                                <p>
                                    With CellCash.in, you can sell mobile online in Hyderabad or any other device from the
                                    comfort of your home or workplace, choosing a pickup time that suits you. Our secure and
                                    transparent system ensures that you get the best value for your used electronics instantly.
                                    Experience the fastest way to trade your old gadgets—sell smart, sell fast with CellCash.in!
                                </p>

                            </div>
                        </div>



                    </div>
                </div>
            </section>
            <section className="trending-podcast-section section-padding bgImage">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12 col-12">
                            <div className="section-title-wrap mb-4">
                                <h4 className="section-title">How Cellcash Works</h4>
                            </div>
                        </div>


                        <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p10 hiw-custom-block" style={{ borderRadius: "9px", backgroundColor: "fff" }}>
                                <div className='row'>
                                    <div className="custom-block-image-wrap textcenter col-lg-3">
                                        <img src={ResearchImg} className="img-fluid hitwIcon" alt="" width={100} height={100} />
                                    </div>
                                    <div className="custom-block-info card-padding col-lg-9">
                                        <h4 className="mb-0">
                                            Choose Device
                                        </h4>
                                        <p className="mb-0">Find the item that you wish to sell by visiting out website or App</p>
                                    </div>
                                </div>


                            </div>
                        </div>
                        {/* <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p10 hiw-custom-block" style={{ borderRadius: "9px", backgroundColor: "fcfbfd" }}>
                                <div className='row'>
                                    <div className="custom-block-image-wrap textcenter col-lg-3">
                                        <img src={RequestImg} className="img-fluid hitwIcon" alt="" width={100} height={100} />
                                    </div>
                                    <div className="custom-block-info card-padding col-lg-9">
                                        <h4 className="mb-0">
                                            Get Instant Quote
                                        </h4>
                                        <p className="mb-0">Answer few questions on your device condition and get instant quote</p>
                                    </div>
                                </div>


                            </div>
                        </div> */}
                        <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p10 hiw-custom-block" style={{ borderRadius: "9px", backgroundColor: "fcfbfd" }}>
                                <div className='row'>
                                    <div className="custom-block-image-wrap textcenter col-lg-3">
                                        <img src={PickUpImg} className="img-fluid hitwIcon" alt="" width={100} height={100} />
                                    </div>
                                    <div className="custom-block-info card-padding col-lg-9">
                                        <h4 className="mb-0">
                                            Schedule Pickup
                                        </h4>
                                        <p className="mb-0">
                                            Provide your details and choose preferred pick up date time slot to place an order with us
                                        </p>
                                    </div>
                                </div>


                            </div>
                        </div>
                        {/* <div className="col-lg-4 col-12 mt-4 mb-lg-0">
                            <div className="custom-block custom-block-full p10 hiw-custom-block" style={{ borderRadius: "9px", backgroundColor: "fcfbfd" }}>
                                <div className='row'>
                                    <div className="custom-block-image-wrap textcenter col-lg-3">
                                        <img src={PhoneImg} className="img-fluid hitwIcon" alt="" width={100} height={100} />
                                    </div>
                                    <div className="custom-block-info card-padding col-lg-9">
                                        <h4 className="mb-0">
                                            Get Pickup Call

                                        </h4>
                                        <p className="mb-0">
                                            Pick up executive will call you for door step pick up of your device.


                                        </p>
                                    </div>
                                </div>


                            </div>
                        </div> */}
                        {/* <div className="col-lg-4 col-12 mt-4 mb-lg-0">
                            <div className="custom-block custom-block-full p10 hiw-custom-block" style={{ borderRadius: "9px", backgroundColor: "fcfbfd" }}>
                                <div className='row'>
                                    <div className="custom-block-image-wrap textcenter col-lg-3">
                                        <img src={VerifyImg} className="img-fluid hitwIcon" alt="" width={100} height={100} />
                                    </div>
                                    <div className="custom-block-info card-padding col-lg-9">
                                        <h4 className="mb-0">
                                            Verification
                                        </h4>
                                        <p className="mb-0">
                                            Get diagnosis of device and verification of your identity.


                                        </p>
                                    </div>
                                </div>


                            </div>
                        </div> */}
                        <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p10 hiw-custom-block" style={{ borderRadius: "9px", backgroundColor: "fcfbfd" }}>
                                <div className='row'>
                                    <div className="custom-block-image-wrap textcenter col-lg-3">
                                        <img src={WalletImg} className="img-fluid hitwIcon" alt="" width={100} height={100} />
                                    </div>
                                    <div className="custom-block-info card-padding col-lg-9">
                                        <h4 className="mb-0">
                                            Get Paid

                                        </h4>
                                        <p className="mb-0">
                                            Get paid as soon as our executive verified your device? Its instant payment all the way!

                                        </p>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="trending-podcast-section section-padding">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12 col-12">
                            <div className="section-title-wrap mb-4">
                                <h4 className="section-title">Why Choose Cellcash?</h4>
                            </div>
                        </div>

                        <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p30 wu-custom-block">
                                <div className="custom-block-image-wrap textcenter" style={{ padding: "0px" }}>

                                    <img src={BestPrice} className="img-fluid" alt="" width={130} height={200} />

                                </div>

                                <div className="custom-block-info" style={{ height: "252px" }}>
                                    <h4 className="mb-2">
                                        Best Price Guaranteed
                                    </h4>



                                    <p className="mb-14">Seal the deal in just few simple steps! Get a price offer, fix a convenient location for pickup and finally, receive payment before the phone leaves your hands.</p>

                                    <p className="mb-10"></p>
                                </div>


                            </div>
                        </div>
                        <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p30 wu-custom-block">
                                <div className="custom-block-image-wrap textcenter">

                                    <img src={Shield} className="img-fluid" alt="" width={130} height={200} />

                                </div>

                                <div className="custom-block-info">
                                    <h4 className="mb-2">
                                        100% Safe & Hassle-Free
                                    </h4>



                                    <p className="mb-0">Based on phone brand, specs, age, condition and market forces this intelligent dynamic tool will delight you with a price that goes far beyond your expectations. No pesky phone calls, no haggling or negotiations.</p>


                                </div>


                            </div>
                        </div>
                        <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p30 wu-custom-block">
                                <div className="custom-block-image-wrap textcenter">

                                    <img src={DeliveryMan} className="img-fluid" alt="" width={130} height={200} />

                                </div>

                                <div className="custom-block-info" style={{ height: "252px" }}>
                                    <h4 className="mb-2">
                                        Free Doorstep Pickup
                                    </h4>



                                    <p className="mb-0">
                                        Our money transfers are digital. Get your money via Bank Account or Paytm, instantly, before your phone leaves your hands. We keep all your financial details confidential and never share any data
                                    </p>


                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="container mt-0">
                <h2 className="text-center mb-4">What Our Customers Say</h2>
                <TestimonialSlider />
            </div>
            <section className="about-section section-padding" id="section_2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-12 mx-auto">
                            <div className="pb-0 mb-0">
                                <div className="section-title-wrap mb-4">
                                    <h4 className="section-title">FAQs</h4>
                                </div>

                                <h6>Frequently Asked Questions (FAQs) for Cellcash.in</h6>

                                <div className="accordion" id="faqAccordion">
                                    {/* FAQ 1 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading1">
                                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse1" aria-expanded="true" aria-controls="faqCollapse1">
                                                1. How does Cellcash.in determine the value of my mobile device?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse1" className="accordion-collapse collapse show" aria-labelledby="faqHeading1" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                We evaluate your mobile device based on several factors including the brand, model, variant, age, functional condition, and physical appearance. You'll be asked to fill out a detailed questionnaire on our website which helps us determine the exact condition of your device and offer you a fair market price.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 2 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading2">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse2" aria-expanded="false" aria-controls="faqCollapse2">
                                                2. What types of mobile devices does Cellcash.in accept?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse2" className="accordion-collapse collapse" aria-labelledby="faqHeading2" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                We accept a wide range of mobile devices from various brands and models. You can enter your device’s details on our website to check if we currently accept your model.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 3 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading3">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse3" aria-expanded="false" aria-controls="faqCollapse3">
                                                3. Is my personal information safe with Cellcash.in?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse3" className="accordion-collapse collapse" aria-labelledby="faqHeading3" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                Yes, protecting your personal information is our top priority. We implement reasonable security measures to protect your data from unauthorized access, use, or disclosure. Please refer to our Privacy Policy for more detailed information.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 4 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading4">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse4" aria-expanded="false" aria-controls="faqCollapse4">
                                                4. How do I schedule a pickup for my device?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse4" className="accordion-collapse collapse" aria-labelledby="faqHeading4" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                Once you receive a valuation for your mobile device and accept the offer, you can schedule a pickup by entering your address and choosing a convenient date and time through our website.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 5 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading5">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse5" aria-expanded="false" aria-controls="faqCollapse5">
                                                5. Can I cancel my request after scheduling a pickup?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse5" className="accordion-collapse collapse" aria-labelledby="faqHeading5" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                Yes, you can cancel your pickup request at any time before the scheduled pickup time. Please contact our customer support to cancel or reschedule.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 6 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading6">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse6" aria-expanded="false" aria-controls="faqCollapse6">
                                                6. How and when will I get paid for my device?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse6" className="accordion-collapse collapse" aria-labelledby="faqHeading6" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                After our representative confirms the condition of your mobile device at your location, payment will be processed immediately via your preferred method—bank transfer, mobile wallet, or cheque.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 7 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading7">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse7" aria-expanded="false" aria-controls="faqCollapse7">
                                                7. What should I do before handing over my mobile device?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse7" className="accordion-collapse collapse" aria-labelledby="faqHeading7" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                We recommend that you back up all your personal data and perform a factory reset on your device to erase personal information. Remove any SIM cards and memory cards before the pickup.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 8 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading8">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse8" aria-expanded="false" aria-controls="faqCollapse8">
                                                8. How can I contact Cellcash.in for more assistance?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse8" className="accordion-collapse collapse" aria-labelledby="faqHeading8" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                If you need further assistance, you can reach us via email at info@cellcash.net or call our customer support line provided on our website.
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>

    )
}

export default SellMobile;